import React, { Suspense } from 'react'
import { Loader, BasePageProps, Content } from '@/tumeloshared'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { changeTitle } from './changeTitle'

const VoteResultLazy = React.lazy(() => import('./VoteResultLazy'))

type Props = BasePageProps

const VoteResultPage: React.FC<Props> = ({ pageTitle }) => {
  changeTitle(pageTitle)
  return (
    <ErrorBoundary>
      <Content>
        <Suspense fallback={<Loader />}>
          <VoteResultLazy />
        </Suspense>
      </Content>
    </ErrorBoundary>
  )
}

export default VoteResultPage
